import { EventEmitter, Injectable } from "@angular/core";
import { OvertimeDriver } from "../models/overtime-drivers.model";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OvertimeDriverStateService {
  
  totalCostUpdated = new EventEmitter<number>();

  private selectedDriver = new Subject<OvertimeDriver | null>();
  private refreshWidgets = new Subject<void>();

  selectedDriver$ = this.selectedDriver.asObservable();
  refreshDriverOvertime$ = this.refreshWidgets.asObservable();

  setSelectedDriver(driver: OvertimeDriver | null) {
    this.selectedDriver.next(driver);
  }

  refreshDriverFinanceList() {
    this.refreshWidgets.next();
  }
}